import { IApp } from "@/interfaces";
import {
  DIGITAL_HUMAN_LOADING,
  DIGITAL_HUMAN_SETTING,
  HANDLE_HYGEN_ICE,
  HYGEN_SESSION_ERROR,
  HYGEN_SESSION_ID,
  HYGEN_SESSION_INFO,
  INIT_DIGITAL_HUMAN,
  INIT_HYGEN_SESSION,
  INTERRUPT_HYGEN_SESSION,
  LIST_ALL_HYGEN_AVATAR,
  SESSION_INITIALIZED_SUCCESSFULLY,
  SPEAK_HYGEN_BOT,
  START_HYGEN_SESSION,
  STOP_HYGEN_SESSION
} from "@/store/modules/digital_human//constants";
import digital_human_setting from "@/utils/digital_human";
import { Commit } from "vuex";
import {
  InitHygenSessionPayload,
  StartHygenSessionPayload,
  SpeakHygenBotPayload,
  HandleHygenIcePayload,
  StopHygenSessionPayload
} from "./interfaces";
import {
  all_heygen_avatar,
  handle_hygen_ice,
  init_hygen_session,
  interrupt_hygen,
  speak_hygen_bot,
  start_hygen_session,
  stop_hygen_session
} from "@/store/apis/hygen";
import { ROOT_ERROR } from "@/store/modules/root/constants";

export default {
  [INIT_DIGITAL_HUMAN]: ({ commit }: { commit: Commit }): void => {
    const portal = process.env.VUE_APP_HR_PORTAL ?? IApp.Portals.AI_LAWYER;
    const settings = { ...digital_human_setting[portal] };
    commit(DIGITAL_HUMAN_SETTING, settings);
  },
  [INIT_HYGEN_SESSION]: async (
    { commit }: { commit: Commit },
    payload: InitHygenSessionPayload
  ): Promise<any | null> => {
    try {
      commit(HYGEN_SESSION_ID, null);
      commit(HYGEN_SESSION_INFO, null);
      commit(HYGEN_SESSION_ERROR, null);
      commit(DIGITAL_HUMAN_LOADING, true);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await init_hygen_session(payload);
      commit(DIGITAL_HUMAN_LOADING, false);
      return response.data.data;
    } catch (e) {
      commit(DIGITAL_HUMAN_LOADING, false);
      commit(HYGEN_SESSION_ERROR, "Failed to initialize session");
      // commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [START_HYGEN_SESSION]: async (
    { commit }: { commit: Commit },
    payload: StartHygenSessionPayload
  ): Promise<any | null> => {
    try {
      commit(HYGEN_SESSION_ERROR, null);
      commit(DIGITAL_HUMAN_LOADING, true);
      const response = await start_hygen_session(payload);
      commit(DIGITAL_HUMAN_LOADING, false);
      commit(SESSION_INITIALIZED_SUCCESSFULLY, true);
      return response.data.data;
    } catch (e) {
      commit(DIGITAL_HUMAN_LOADING, false);
      commit(HYGEN_SESSION_ERROR, "Failed to start session");
      // commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [SPEAK_HYGEN_BOT]: async (
    { commit }: { commit: Commit },
    payload: SpeakHygenBotPayload
  ): Promise<any | null> => {
    try {
      const response = await speak_hygen_bot(payload);
      return response.data.data;
    } catch (e) {
      commit(HYGEN_SESSION_ERROR, "Failed to get response from bot");
      return null;
    }
  },
  [HANDLE_HYGEN_ICE]: async (
    { commit }: { commit: Commit },
    payload: HandleHygenIcePayload
  ): Promise<any | null> => {
    try {
      const response = await handle_hygen_ice(payload);
      return response.data.data;
    } catch (e) {
      // commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [STOP_HYGEN_SESSION]: async (
    { commit }: { commit: Commit },
    payload: StopHygenSessionPayload
  ): Promise<any | null> => {
    try {
      const response = await stop_hygen_session(payload);
      return response.data.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [INTERRUPT_HYGEN_SESSION]: async (
    { commit }: { commit: Commit },
    payload: StopHygenSessionPayload
  ): Promise<any | null> => {
    try {
      const response = await interrupt_hygen(payload);
      return response.data.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [LIST_ALL_HYGEN_AVATAR]: async ({
    commit
  }: {
    commit: Commit;
  }): Promise<any | null> => {
    try {
      const response = await all_heygen_avatar();
      return response.data.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  }
};
